import { render, staticRenderFns } from "./LmFormEmptySpaceBuilderUi.vue?vue&type=template&id=6b088839"
import script from "./LmFormEmptySpaceBuilderUi.vue?vue&type=script&lang=js"
export * from "./LmFormEmptySpaceBuilderUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports